<div style="width: 100%; height: 100%; display: block">
  <canvas
    style="width: 100%; height: 100%"
    (mousemove)="mouseEvent($event)"
    (mousedown)="mouseEvent($event)"
    (mouseup)="mouseEvent($event)"
    (mouseout)="mouseEvent($event)"
    (mouseover)="mouseEvent($event)"
    (mouseoutside)="mouseEvent($event)"
    #canvas
  ></canvas>
</div>
